import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AppRoute = ({ permissions, children }) => {
  const { hasAnyPermission, loading } = useAuth();

  if (!localStorage.getItem("token")) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return null;
  }

  // If route has required permissions and user lacks them, redirect to dashboard
  if (permissions && permissions.length > 0 && !hasAnyPermission(permissions)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AppRoute;
